var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import HTTP from "@/http";
import snackbarBus from "@/snackbarBus";
import likesBus from "@/likesBus";
import ButtonLikeAudio from "@/components/ButtonLikeAudio";
import MenuAddToPlaylist from "@/components/MenuAddToPlaylist";
import DialogAddTag from "@/components/DialogAddTag";
import AudioImage from "@/components/AudioImageWithOverlay";
var PageTrack = (function (_super) {
    __extends(PageTrack, _super);
    function PageTrack() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activeTab = "lyrics";
        _this.atpMenu = false;
        _this.dialogAddTag = false;
        _this.track = null;
        _this.state = _this.$store.state;
        _this.playlists = [];
        _this.liked = false;
        return _this;
    }
    Object.defineProperty(PageTrack.prototype, "embedURL", {
        get: function () {
            if (!this.track.lyricsSource) {
                return null;
            }
            return this.track.lyricsSource.replace(/songs/, "embed/songs");
        },
        enumerable: true,
        configurable: true
    });
    PageTrack.prototype.getTrack = function () {
        var _this = this;
        HTTP.get("audios/" + this.id, { params: { with: ["tags", "user"] } }).then(function (response) {
            _this.track = response.data;
            _this.$nextTick(function () {
                document.title = _this.track.artist + " - " + _this.track.name;
                _this.liked = _this.track.liked;
            });
        }, function (response) {
        });
    };
    PageTrack.prototype.isInUsersPlaylist = function (playlistId) {
        return this.track.user_playlists.map(function (e) {
            return e.id;
        }).includes(playlistId);
    };
    PageTrack.prototype.like = function () {
        var _this = this;
        HTTP.post("likes", { audioId: this.id })
            .then(function (response) {
            snackbarBus.$emit("show", "Liked");
            _this.liked = true;
        })
            .catch(function (error) {
            snackbarBus.$emit("show", "There was an error. Try again");
        });
    };
    PageTrack.prototype.unlike = function () {
        var _this = this;
        HTTP.delete("likes", { params: { audioId: this.id } })
            .then(function (response) {
            snackbarBus.$emit("show", "Like removed");
            _this.liked = false;
        })
            .catch(function (error) {
            snackbarBus.$emit("show", "There was an error. Try again");
        });
    };
    PageTrack.prototype.deleteTrack = function () {
        var _this = this;
        var params = {};
        HTTP.delete('tracks/' + this.id, params).then(function (response) {
            _this.$router.push("/");
        }, function (response) {
        });
    };
    PageTrack.prototype.getPlaylists = function () {
        var _this = this;
        var params = {};
        HTTP.get('users/me/playlists', params).then(function (response) {
            _this.playlists = response.data;
        }, function (response) {
        });
    };
    PageTrack.prototype.onRouteChanged = function () {
        this.track = null;
        this.getTrack();
    };
    PageTrack.prototype.onStorePlaylistsChange = function (val) {
        this.playlists = val;
    };
    PageTrack.prototype.onPlaylistsChange = function (val) {
        var _this = this;
        if (val && val.length) {
            this.liked = this.state.user.user.liked && this.state.user.user.liked.some(function (audio) { return +audio.id === +_this.id; });
        }
    };
    PageTrack.prototype.onDialogAddTagToggle = function (newVal) {
        if (!newVal) {
            this.getTrack();
        }
    };
    PageTrack.prototype.created = function () {
        var _this = this;
        likesBus.$on("toggled", function (audio, liked) {
            _this.track.liked = liked;
        });
    };
    __decorate([
        Prop([Number, String]),
        __metadata("design:type", Object)
    ], PageTrack.prototype, "id", void 0);
    __decorate([
        Watch("$route", { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PageTrack.prototype, "onRouteChanged", null);
    __decorate([
        Watch("state.user.user.playlists", { deep: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], PageTrack.prototype, "onStorePlaylistsChange", null);
    __decorate([
        Watch("playlists", { immediate: true, deep: true, }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], PageTrack.prototype, "onPlaylistsChange", null);
    __decorate([
        Watch("dialogAddTag"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], PageTrack.prototype, "onDialogAddTagToggle", null);
    PageTrack = __decorate([
        Component({
            components: {
                'like': ButtonLikeAudio,
                MenuAddToPlaylist: MenuAddToPlaylist,
                DialogAddTag: DialogAddTag,
                AudioImage: AudioImage,
            },
        })
    ], PageTrack);
    return PageTrack;
}(Vue));
export default PageTrack;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/Pages/PageTrack.vue
// module id = 241
// module chunks = 0